export class InsuranceCoverageModel {

  OC: boolean;
  AC: boolean;
  NNW: boolean;
  ASSISTANCE: boolean;
  AC_MINI: boolean;

  constructor(oc: boolean) {
    this.OC = oc;
    this.AC = false;
    this.NNW = false;
    this.ASSISTANCE = false;
    this.AC_MINI = false;
  }
}
